var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRabbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000106869433907909548760000010501333815734020245_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.9,
    cy: 32.9,
    r: 2.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.1,79.3L51.2,84c0.4,0.1,0.8-0.2,0.8-0.6c-0.5-4.7-1.5-26.2,20.3-16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,75.7V85c0,0-11,0.3-10.2,8.4h20l0.2-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27,81.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,75.7c0,0-4.7-5.3-7.1-12.1S21.1,45,21.1,45C12.8,44.5,7,42.6,7,37.6c0-5.7,7.7-13.3,18.2-13.3 c1.3,0,10.8-20,13.3-17.4c9.6,10,0.6,20.9,0.6,20.9c0.9,1.2,3.9,2.6,5.1,6.9s-0.2,8.6-4.4,10.5c0,0,36-9.8,46.1,14.1 S80.2,93,80.2,93H42.4c-0.8-8.1,8.8-9,8.8-9l6.8,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.1,88c1.4,0.9,3.1,1.4,4.9,1.4c4.6,0,8.4-3.3,8.4-7.4s-3.8-7.4-8.4-7.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbit);
export default __webpack_public_path__ + "static/media/rabbit.f71c7d0566532f96472a8c46090d9dc9.svg";
export { ForwardRef as ReactComponent };